import searchIcon from 'bootstrap-italia/src/svg/it-search.svg';

import SearchRubricaView from 'uniba-volto-persone/components/Blocks/SearchRubrica/View';
import SearchRubricaEdit from 'uniba-volto-persone/components/Blocks/SearchRubrica/Edit';
import SearchStruttureView from 'uniba-volto-persone/components/Blocks/SearchStrutture/View';
import SearchStruttureEdit from 'uniba-volto-persone/components/Blocks/SearchStrutture/Edit';
import { cloneBlock } from 'design-comuni-plone-theme/helpers/blocks';

const addonBlocks = {
    searchRubrica: {
        id: 'searchRubrica',
        title: 'Ricerca nella rubrica',
        icon: searchIcon,
        group: 'search',
        view: SearchRubricaView,
        edit: SearchRubricaEdit,
        restricted: false,
        mostUsed: false,
        cloneData: cloneBlock,
        security: {
            addPermission: [],
            view: [],
        },
        sidebarTab: 1,
    },

    searchStrutture: {
        id: 'searchStrutture',
        title: 'Ricerca tra le strutture',
        icon: searchIcon,
        group: 'search',
        view: SearchStruttureView,
        edit: SearchStruttureEdit,
        restricted: false,
        mostUsed: false,
        cloneData: cloneBlock,
        security: {
            addPermission: [],
            view: [],
        },
        sidebarTab: 1,
    },
}

const getAddonBlocks = (config) => {
    return addonBlocks;
};
export default getAddonBlocks;